import { PurchaseOrder } from "./purchaseOrder";

export class PurchaseOrderWrapper {
    purchaseOrder: PurchaseOrder = new PurchaseOrder();
    newName: string;
}
